export const LOADING = 'OPERATION-DOCUMENT-LOADING';
export const NEEDED = 'OPERATION-DOCUMENT-NEEDED';
export const COMPLETED = 'OPERATION-DOCUMENT-COMPLETED';
export const DOCUMENTS = 'OPERATION-DOCUMENT-DOCUMENTS';
export const GROUPS = 'OPERATION-DOCUMENT-GROUPS';
export const GROUPSCATEGORIES = 'OPERATION-DOCUMENT-GROUPSCATEGORIES';
